/** Dentro do app instalado (shell nativo) não existe página de apresentação: abre direto na entrada. */
export function isNativeShell(): boolean {
  const capacitor = (window as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return capacitor?.isNativePlatform?.() === true;
}
